// extracted by mini-css-extract-plugin
export default {"exploreBenefits":"explore-benefits_exploreBenefits","exploreBenefitsLink":"explore-benefits_exploreBenefitsLink"};